import { render, staticRenderFns } from "./withdrawDeposit.vue?vue&type=template&id=06520235&scoped=true"
import script from "./withdrawDeposit.vue?vue&type=script&lang=js"
export * from "./withdrawDeposit.vue?vue&type=script&lang=js"
import style0 from "./withdrawDeposit.vue?vue&type=style&index=0&id=06520235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06520235",
  null
  
)

export default component.exports